export enum AppStatusGeneral {
    paramsSchemaMismatch = "paramsSchemaMismatch"
}
